export const SET_URL_PARAM = 'SET_URL_PARAM';
export const SET_ALL_URL_PARAMS = 'SET_ALL_URL_PARAMS';

export const setUrlParam = (key, value) => ({
  type: SET_URL_PARAM,
  key,
  value,
});
export const setUrlParams = params => ({ type: SET_ALL_URL_PARAMS, params });
